import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../../SectionHeading';

const worlds = [
  { world: 'Pământ', population: '~3 miliarde', role: 'Biosferă în recuperare, centru politic și istoric', color: 'text-green-400', dot: 'bg-green-400' },
  { world: 'Mercur', population: '450.000', role: 'Producție de energie și cristale cuantice; alimentează sistemul solar', color: 'text-orange-400', dot: 'bg-orange-400' },
  { world: 'Venus', population: '1 milion', role: 'Paradis terraformat; oceane calde, ceruri ambrate, plaje de nisip negru', color: 'text-amber-400', dot: 'bg-amber-400' },
  { world: 'Marte', population: '~10 milioane', role: 'Prima republică planetară independentă', color: 'text-red-400', dot: 'bg-red-400' },
  { world: 'Centura', population: '200.000', role: 'Transport și reziliență; „ligamentele sistemului solar"', color: 'text-gray-400', dot: 'bg-gray-400' },
  { world: 'Sistemul Jupiter', population: '1,3 milioane', role: 'Combustibil heliu-3, exporturi de apă, biosfera sacră a Europei', color: 'text-yellow-400', dot: 'bg-yellow-400' },
  { world: 'Sistemul Saturn', population: '520.000', role: 'Artiștii și piloții lui Titan; custodia Enceladus', color: 'text-purple-400', dot: 'bg-purple-400' },
  { world: 'Neptun / Triton', population: '~50.000', role: 'Ultimul far; poartă spre spațiul interstelar', color: 'text-blue-400', dot: 'bg-blue-400' },
];

const WorldTableRo = () => (
  <section className="py-24 bg-brand-dark border-t border-white/5">
    <div className="max-w-5xl mx-auto px-6 lg:px-8">
      <SectionHeading title="Cele Opt Lumi Locuite" subtitle="Civilizație Solară" />

      {/* Desktop Table */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="hidden md:block bg-brand-surface border border-white/5 rounded-2xl overflow-hidden"
      >
        <table className="w-full">
          <thead>
            <tr className="border-b border-white/10 bg-white/5">
              <th className="text-left px-6 py-4 text-brand-accent font-semibold text-sm uppercase tracking-widest">Lume</th>
              <th className="text-left px-6 py-4 text-brand-accent font-semibold text-sm uppercase tracking-widest">Populație</th>
              <th className="text-left px-6 py-4 text-brand-accent font-semibold text-sm uppercase tracking-widest">Rol în Civilizație</th>
            </tr>
          </thead>
          <tbody>
            {worlds.map((row, i) => (
              <tr key={i} className="border-b border-white/5 last:border-0 hover:bg-white/3 transition-colors">
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <span className={`w-2 h-2 rounded-full flex-shrink-0 ${row.dot}`}></span>
                    <span className={`font-display font-bold ${row.color}`}>{row.world}</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-white font-medium">{row.population}</td>
                <td className="px-6 py-4 text-gray-400 text-sm leading-relaxed">{row.role}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </motion.div>

      {/* Mobile Cards */}
      <div className="md:hidden space-y-4">
        {worlds.map((row, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.05 }}
            className="bg-brand-surface border border-white/5 rounded-xl p-5"
          >
            <div className="flex items-center gap-3 mb-2">
              <span className={`w-2 h-2 rounded-full flex-shrink-0 ${row.dot}`}></span>
              <span className={`font-display font-bold text-lg ${row.color}`}>{row.world}</span>
            </div>
            <p className="text-white font-semibold text-sm mb-1">{row.population}</p>
            <p className="text-gray-400 text-sm leading-relaxed">{row.role}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default WorldTableRo;